module.exports = __webpack_public_path__ + "img/Flexibility to work how you want.6e06a9ab.gif";